import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

const styles = {
    container: ({ isFullMode, withBorder }: { isFullMode: boolean; withBorder: boolean }): string =>
        buildCssClassName(
            "flex shrink-0 min-h-max md:[min-height:unset]",
            [isFullMode && "md:basis-[170px]"],
            withBorder && [
                "pr-[7px]",
                "border-r-[2px]",
                "border-gray-400",
                "border-dashed",
                "relative",
                "after:absolute",
                "after:w-[2px]",
                "after:h-[6px]",
                "after:bg-gray-500",
                "after:[left:auto]",
                "after:right-[-2px]"
            ]
        ),
    wrapper: ({
        isFullMode,
        withPaddings,
        isLastOrdered,
        withBottomBorder,
        isCurrentModule,
        isActionAffected
    }: {
        isFullMode: boolean
        withPaddings: boolean
        isLastOrdered: boolean
        withBottomBorder: boolean
        isCurrentModule: boolean
        isActionAffected: boolean
    }): string =>
        buildCssClassName(
            [
                "cursor-pointer",
                "flex",
                "flex-col",
                "gap-y-[10px]",
                "rounded-[10px]",
                "h-full",
                "w-full",
                "md:min-w-max",
                "min-h-[90px]",
                "max-h-[90px]",
                "md:max-h-[155px]",
                "md:h-[155px]"
            ],
            [isFullMode ? "max-w-[90px]" : "max-w-min"],
            isCurrentModule && "bg-gray-400 md:bg-blue-600",
            isActionAffected && "md:bg-gray-500 bg-gray-400",
            withPaddings ? "py-[15px] px-[20px]" : "p-[5px] md:pt-[5px] md:pb-[10px] md:px-[10px]",
            !isLastOrdered && withBottomBorder && "border-b-[1px] border-gray-500",
            getTransitionTwClasses("all", 100)
        ),
    title: (): string => "md:px-[5px] md:py-[3px] md:w-max select-none truncate !mb-[-5px] md:mb-0",
    phasesContainer: (): string => "flex mt-auto gap-x-[6px] md:gap-x-[10px]",
    phasesWrapper: (): string => "flex h-full gap-x-[5px] mt-auto",
    rsvpContainer: (): string => "flex",
    rsvp: ({
        isStub,
        isSessionPresent,
        isFullMode
    }: {
        isStub: boolean
        isSessionPresent: boolean
        isFullMode: boolean
    }): string =>
        buildCssClassName(
            [
                "flex",
                "flex-col",
                [isFullMode && "md:mx-[5px]"],
                "gap-y-[5px]",
                "relative",
                [isFullMode ? "md:bottom-[5px]" : [isStub && "md:bottom-[10px]"]],
                [!isFullMode && "[pointer-events:none] [cursor:default]"],
                "items-center",
                "mt-auto",
                "rounded-full",
                "border-[1px]",
                "max-w-[30px]",
                "border-transparent",
                "select-none"
            ],
            [
                isStub || !isSessionPresent
                    ? ["![cursor:auto]", [isFullMode && ["mx-[5px]", "mb-[5px]"]]]
                    : [
                          ["p-[5px]", isFullMode && "md:mb-[5px]"],
                          [
                              isFullMode && [
                                  "cursor-pointer",
                                  "md:focus:border-lightblue-200",
                                  "md:hover:border-lightblue-200",
                                  "md:hover:bg-lightblue-400",
                                  "md:focus:bg-lightblue-400"
                              ]
                          ]
                      ]
            ]
        )
}

export { styles as moduleExcerptStyles }
